<template>
  <div>
    <SeccionPostulacion
      titulo="POSTULACIÓN PERIODO PRINCIPAL"
      texto1="En esta sección podrás descargar el "
      destacado="comprobante de la postulación "
      texto2="realizada durante el periodo principal de postulación."
      :postulaciones="postulaciones.filter(p => p.periodo == 1)"
    />
    <SeccionResultado
      titulo="RESULTADOS PERIODO PRINCIPAL"
      texto1="En esta sección podrás descargar el "
      destacado="comprobante de resultado "
      texto2="de la postulación realizada durante el periodo principal de postulación."
      :resultados="
        resultados
          .filter(p => p.periodo == 1 || p.periodo == 2)
          .sort((a, b) => (a.periodo > b.periodo ? 1 : -1))
      "
    />
    <SeccionPostulacion
      titulo="POSTULACIÓN PERIODO COMPLEMENTARIO"
      texto1="En esta sección podrás descargar el "
      destacado="comprobante de la postulación "
      texto2="realizada durante el periodo complementario de postulación."
      :postulaciones="postulaciones.filter(p => p.periodo == 2)"
    />
    <SeccionResultado
      titulo="RESULTADOS PERIODO COMPLEMENTARIO"
      texto1="En esta sección podrás descargar el "
      destacado="comprobante de resultado "
      texto2="de la postulación realizada durante el periodo complementario de postulación."
      :resultados="resultados.filter(p => p.periodo == 3)"
    />
  </div>
</template>

<script>
import ApiPostulacion from "@/services/ApiPostulacion";
import ApiResultado from "@/services/ApiResultados";
import SeccionPostulacion from "@/components/postulante/SeccionPostulacion";
import SeccionResultado from "@/components/postulante/SeccionResultado";
export default {
  components: {
    SeccionPostulacion,
    SeccionResultado
  },
  data() {
    return {
      postulaciones: [],
      resultados: []
    };
  },
  beforeMount() {
    this.obtenerPostulacionesEnviadas();
    this.obtenerResultados();
  },
  methods: {
    async obtenerPostulacionesEnviadas() {
      this.postulaciones = await ApiPostulacion.obtenerPostulaciones(
        this.$route.params.runPostulante,
        this
      );
    },
    async obtenerResultados() {
      this.resultados = await ApiResultado.obtenerResultados(
        this.$route.params.runPostulante,
        this
      );
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/Comprobantes.vue